import HOCWatchValue from 'components/common/hoc-watch-value';
import TableEditableComponent from 'components/elements/table/table';
import { ColumnDataType } from 'components/elements/table/type';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function TourParticipantDetailTable(props: {
  parentIndex: number;
}) {
  const { t } = useTranslation();
  const name: any = `approvalable.tourSales.0.tourSaleGuests.${props.parentIndex}`;
  const value = HOCWatchValue({ keys: [name] });
  const data = value[name];

  const columns = [
    {
      header: t('common:type'),
      accessorKey: 'tourPrice',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:bed'),
      accessorKey: 'bedType',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:note'),
      accessorKey: 'note',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:group'),
      accessorKey: 'groupNumber',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:schedule'),
      accessorKey: 'tourFlightName',
      minSize: 100,
      dataType: ColumnDataType.text,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <TableEditableComponent
        columns={columns}
        data={[data]}
        dispatch={() => {}}
        disabled
        name={name}
      />
    </div>
  );
}
